export class EncodingUtils {
  public static camelToKebabCase(val: string) {
    let result: string = val;

    // Convert camelCase capitals to kebab-case.
    result = result.replace(/([a-z][A-Z])/g, (match) => `${match.substr(0, 1)}-${match.substr(1, 1).toLowerCase()}`);

    // Convert non-camelCase capitals to lowercase.
    result = result.toLowerCase();

    // Convert non-alphanumeric characters to hyphens
    result = result.replace(/[^-a-z\d]+/g, '-');

    // Remove hyphens from both ends
    result = result.replace(/^-+/, '').replace(/-$/, '');

    return result;
  }

  public static kebabCaseToCamel(val: string): string {
    return val.replace(/-([a-z])/gi, ($0, $1) => $1.toUpperCase());
  }

  public static encodeRequest(o: any): any {
    if (typeof o === 'string') {
      return EncodingUtils.camelToKebabCase(o);
    }
    let newO: any;
    let newKey: string;
    let value;
    if (o instanceof Array) {
      newO = [];
      for (const origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          value = o[origKey];
          // if (typeof value === 'object') {
          if (value instanceof Object) {
            value = EncodingUtils.encodeRequest(value);
          } else {
          }
          newO.push(value);
        }
      }
    } else {
      newO = {};
      for (const origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = EncodingUtils.camelToKebabCase(origKey);
          value = o[origKey];
          if (value !== null && value !== undefined && value.constructor === Object) {
            value = EncodingUtils.encodeRequest(value);
          } else if (value instanceof Array) {
            value = EncodingUtils.encodeRequest(value);
          } else if (value instanceof Object) {
            value = EncodingUtils.encodeRequest(value);
          }
          newO[newKey] = value;
        }
      }
    }
    return newO;
  }

  public static decodeResponse(o: any): any {
    if (typeof o === 'string') {
      return EncodingUtils.kebabCaseToCamel(o);
    }
    let newO: any;
    let newKey: string;
    let value;
    if (o instanceof Array) {
      newO = [];
      for (const origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          value = o[origKey];

          if (typeof value === 'object') {
            value = EncodingUtils.decodeResponse(value);
          }
          newO.push(value);
        }
      }
    } else {
      newO = {};
      for (const origKey in o) {
        if (o.hasOwnProperty(origKey)) {
          newKey = EncodingUtils.kebabCaseToCamel(origKey);
          value = o[origKey];
          if (value !== null && value.constructor === Object) {
            value = EncodingUtils.decodeResponse(value);
          } else if (value instanceof Array) {
            value = EncodingUtils.decodeResponse(value);
          }
          newO[newKey] = value;
        }
      }
    }
    return newO;
  }
}
